import BaseMetricCard from "../../../Common/BaseMetricCard";
import { WellnessScoreStatus } from "../../../Common/types";
import { useTranslation } from "react-i18next";
import { getSleepStatus, getSleepDisplayValue } from "./utils";

export interface SleepCardProps {
  hoursPerNight: number;
  /** When present (e.g. from health trends API), used as metric display instead of deriving from hoursPerNight */
  valueDisplayLabel?: string;
  lastUpdated?: string;
}

const config = {
  translationPrefix: "Sleep",
  analyticsSource: "Health Score - sleep",
  manualEntryRoute: "/home/health-score/lifestyle-questionnaire",
  ctaRoute: "/home/health-score/lifestyle-questionnaire",
};

export default function SleepCard(props: SleepCardProps) {
  const { hoursPerNight, valueDisplayLabel, lastUpdated } = props;
  const { t } = useTranslation();

  const status: WellnessScoreStatus = getSleepStatus(hoursPerNight);
  const metricValue = valueDisplayLabel ?? getSleepDisplayValue(hoursPerNight);
  const unit = t("Sleep.unit");

  return (
    <BaseMetricCard
      metricValue={metricValue}
      status={status}
      lastUpdated={lastUpdated}
      unit={unit}
      config={config}
    />
  );
}
